import { useAuthStore } from '@/store/auth'
import { QueryStringKeys } from '@/constants/commons'

export default defineNuxtPlugin(nuxtApp => {
  const authStore = useAuthStore()
  const route = useRoute()

  nuxtApp.hook('page:finish', () => {
    if (route.query[QueryStringKeys.REDIRECT_URL] && !authStore.isLogin && !authStore.isLoginModalShown) {
      authStore.openLoginModal()
    }
  })
})
